import { GlobalTokens } from "../../../@tokens/GlobalTokens";

export const style: any = {
    theme: {
        spacing: GlobalTokens.SpacingSizeXxxs
      }
}